export enum UserConfirmationMethod {
  Password = 0,
  Pin = 1,
  None = 10
}
